import React from "react";

import { MainLeftTitle } from "../../../_uiComponents/WrapperComponents";
import LcvCampaignSelect from "../shared/LcvCampaignSelect";
import LcvGameReportGrid from "./views/LcvGameReportGrid";

export default function LcvGameReportWrapper() {
     return (
          <>
               <MainLeftTitle title="LCV Game Report" />

               <LcvCampaignSelect />

               <LcvGameReportGrid />
          </>
     );
}
